import React from 'react';

const NewCollections = () => {
  const specialties = [
    {
      id: 1,
      title: 'Naturstein',
      image: '/images/projekte/Naturstein/naturstein.jpg'
    },
    {
      id: 2,
      title: 'Großformat-Fliesen',
      image: '/images/projekte/projekt3/WhatsApp Image 2025-06-29 at 10.50.08.jpeg'
    },
    {
      id: 3,
      title: 'Bad & WC',
      image: '/images/projekte/projekt2/WhatsApp Image 2025-06-29 at 10.51.35 (3).jpeg'
    }
  ];

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Side - Text Content */}
          <div className="pt-8">
            <h2 className="text-4xl lg:text-5xl font-normal text-stone-900 leading-tight mb-6">
              Unsere<br />
              Spezialgebiete
            </h2>
            <p className="text-stone-600 text-base leading-relaxed mb-12 max-w-sm">
              Mit über 20 Jahren Erfahrung haben wir uns auf verschiedene Bereiche spezialisiert. Von edlem Naturstein bis zu modernen Großformat-Fliesen - wir beherrschen alle Techniken perfekt.
            </p>
            <a href="#contact" className="border border-stone-400 text-stone-700 px-6 py-3 text-sm font-light tracking-wide hover:bg-stone-700 hover:text-white transition-all duration-300 inline-block">
              Beratung anfragen
            </a>
          </div>

          {/* Right Side - Three Images */}
          <div className="grid grid-cols-3 gap-4">
            {specialties.map((specialty) => (
              <div key={specialty.id} className="group">
                {/* Image with Hover Animation */}
                <div className="aspect-[3/4] mb-3 overflow-hidden">
                  <img 
                    src={specialty.image}
                    alt={specialty.title}
                    className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                  />
                </div>
                
                {/* Title */}
                <h3 className="text-stone-800 text-sm font-medium text-center leading-tight">
                  {specialty.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewCollections; 